import Api from '../../lib/request'
import COOKIECONSTANT from '../../constant/cookie'
import cookie from '../../lib/cookie'

let tracker

tracker = (options) => {
  setTimeout(() => {
    return new Promise((resolve, reject) => {
      const url = `${COOKIECONSTANT.REQUEST_HOST}`
      const op = JSON.stringify(options)
      Api.post(url, op, {
        headers: {
          // 'X-Host': 'mall.report.event', // 老版数据上报
          'X-Host': 'mall.report.event-v2',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
      }).then((data) => {
        if (data.status !== 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
    })
  }, 1000);
}

const fakeTracker = (options) => {
  console.log('====================================')
  console.log('tracking data', (options))
  console.log('====================================')
}

// if (process.env === 'development') {
//   tracker = fakeTracker
// }

export default tracker
